// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"10318c2fc319b74cb02f","147":"0c07f7b0443c23878052","251":"b6b84b7b53105ae2582b","352":"a24e00e897355eeff304","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};